import { createSlice } from "@reduxjs/toolkit";
import initialState from "./state";
import { getLogin } from "./actionCreator";

export const loginSlice = createSlice({
  name: "login",
  initialState,
  extraReducers: (builder) => {
    // GET Student User
    builder.addCase(getLogin.pending, (state) => { });
    builder.addCase(getLogin.fulfilled, (state, action) => {
      // console.log(action.payload.success, "ation login")
      state.user = action?.payload?.data?.payload;
      state.isLoggedIn = action.payload.success;
      // console.log(action?.payload?.data?.payload, "hello login");
    });
    builder.addCase(getLogin.rejected, (state, action) => {
      state.error = action?.error?.message;
    });
  },
});

export default loginSlice.reducer;
